module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetMedium.6968638.jpg";